import { render, staticRenderFns } from "./RemotePrinterConfigurationPage.vue?vue&type=template&id=7b45475c&scoped=true&"
import script from "./RemotePrinterConfigurationPage.vue?vue&type=script&lang=ts&"
export * from "./RemotePrinterConfigurationPage.vue?vue&type=script&lang=ts&"
import style0 from "./RemotePrinterConfigurationPage.vue?vue&type=style&index=0&id=7b45475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45475c",
  null
  
)

export default component.exports